import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export const strollResource = Vue.resource('strolls{/id}/?limit=1000')